<h1 mat-dialog-title> Crear Carga Masiva </h1> <br/>

<form #cargaMasivaForm = ngForm>

    <mat-dialog-content>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Tipo de Carga </mat-label>
                
                <mat-select name = "tipoCarga" #tipoCarga = "ngModel" [(ngModel)] = "cargaMasiva.tipoCarga" required>

                    <mat-option *ngFor = "let tipo of data.tipoCarga" value = "{{tipo}}">
                        
                        {{tipo}} 

                    </mat-option>

                </mat-select> 

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Archivo </mat-label>
                
                <input name = "archivo" matInput [value] = "cargaMasiva?.archivo?.name" disabled = "true" />

            </mat-form-field>
            
            <input #csvInput hidden = "true" type = "file" enctype = "multipart/form-data" onclick = "this.value = null" 
            (change) = "csvInputChange($event)" accept = ".csv"/>

            <button mat-flat-button color = "primary" (click) = "csvInput.click()"> Seleccione Archivo (CSV) </button>

        </p>

    </mat-dialog-content> <br/> 

    <mat-dialog-actions>

        <button mat-button class = "mat-raised-button btn-info" (click) = "descargarPlanilla()" 
        [disabled] = "cargaMasivaForm.invalid"> 

            <i class = "fa fa-download"> </i> Descargar Planilla

        </button>

        <button mat-button class = "mat-raised-button btn-success" (click) = "crearCargaMasiva()" 
        [disabled] = "cargaMasivaForm.invalid"> 

            <i class = "fa fa-plus"> </i> Crear

        </button>
        
        <button mat-button class = "mat-raised-button btn-dark" (click) = "onCancelarClick()"> 
            <i class = "fa fa-trash"> </i> Salir
        </button>
        
    </mat-dialog-actions>

</form>